<script setup>
import DataTable from "@/components/global-themed/table/DataTable.vue";
import TableBody from "@/components/global-themed/table/TableBody.vue";
import ZeroContent from "@/components/global-themed/ZeroContent.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import BannerTableHeader from "@/components/admin/banners/partials/table/BannerTableHeader.vue";
import BannerRow from "@/components/admin/banners/partials/table/BannerRow.vue";
import {useAdminBanners, useUpdateBanner} from "@/composables/admin/useAdminBanners.js";

const {data: banners, isLoading} = useAdminBanners();
const {mutate: updateBanner} = useUpdateBanner();

function toggleActive(banner) {
  updateBanner({
    id: banner.id,
    payload: {
      title: banner.title,
      cta_url: banner.cta_url,
      active: !banner.active,
      currency: banner.currency,
      fallback_images: banner.fallback_images,
    },
  });
}
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-flex-col tw-gap-y-8">
      <div class="tw-flex tw-items-center tw-justify-between">
        <h1 class="tw-font-bold tw-text-4.5xl tw-text-neutral-900">
          Banner Management
        </h1>

        <DefaultButton
          variant="primary"
          size="small"
          as="a"
          href="/admin/banners/create"
        >
          <svg-vue
            icon="icons/plus"
            class="tw-w-4 tw-h-4 tw-mr-2"
          />
          <span class="tw-font-semibold tw-antialiased">Create Banner</span>
        </DefaultButton>
      </div>

      <div
        v-if="isLoading"
        class="tw-bg-white tw-p-8 tw-rounded-lg"
      >
        <LoadingBlock />
      </div>

      <div
        v-else
        class="tw-bg-white tw-p-8 tw-rounded-lg tw-flex tw-flex-col tw-gap-y-8"
      >
        <DataTable>
          <BannerTableHeader />

          <TableBody v-if="banners?.length > 0">
            <BannerRow
              v-for="banner in banners"
              :key="banner.id"
              :banner="banner"
              @toggle-active="toggleActive"
            />
          </TableBody>

          <ZeroContent v-if="!banners || !banners.length">
            Looks like there are no banners to display.
          </ZeroContent>
        </DataTable>
      </div>
    </div>
  </div>
</template>
